import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider
} from 'react-router-dom'

// pages
import Home from './pages/Home'
import Resume from './pages/resume'
import Comming from './pages/comming'
import NotFound from './pages/NotFound'
import fonts from './fontawesome/css/all.min.css'

// layouts
import RootLayout from './layouts/RootLayout'
import { useEffect } from 'react'

//getichpages






const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<Home />} />
      <Route path='/resume' element={<Resume />} />
      <Route path='/coming' element={<Comming />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  )
)

function App() {

  return (
    <RouterProvider router={router} />
  );
}

export default App
